import React from 'react';
import PropTypes from 'prop-types';
import {
  DoughnutsWrapper,
  ClassroomIconWrapper,
  PercentWrapper,
  LegendWrapper,
  AttemptIconWrapper
} from './styled';
import DoughnutsClassroomIcon from '../doughnuts-classroom-icon/doughnuts-classroom-icon';
import DoughnutsLegend from '../doughnuts-legend/doughnuts-legend';
import DoughnutsInner from '../doughnuts-inner/doughnuts-inner';
import { CLASSROOM } from '../doughnuts-inner/doughnuts-inner-hooks';
import { Attempt } from '../../helpers/icon-dictionary';

const Doughnuts = ({ i18n, data }) => {
  const { resultType = CLASSROOM, classroomPct, groupPct, studentPct, studentName } = data;
  const percentages = [classroomPct, groupPct, studentPct];
  return (
    <DoughnutsWrapper>
      <DoughnutsInner i18n={i18n} {...data} />
      <ClassroomIconWrapper type={resultType}>
        <DoughnutsClassroomIcon type={resultType} i18n={i18n} />
      </ClassroomIconWrapper>
      <PercentWrapper type={resultType}>
        {percentages[resultType] ? `${percentages[resultType]}%` : i18n.t`NA`}
      </PercentWrapper>
      <AttemptIconWrapper type={resultType}>
        <img src={Attempt} alt="attempt icon" />
      </AttemptIconWrapper>
      <LegendWrapper type={resultType}>
        <DoughnutsLegend i18n={i18n} type={resultType} studentName={studentName} />
      </LegendWrapper>
    </DoughnutsWrapper>
  );
};

Doughnuts.propTypes = {
  i18n: PropTypes.object,
  data: PropTypes.shape({
    resultType: PropTypes.number,
    classroomPct: PropTypes.number,
    groupPct: PropTypes.number,
    studentPct: PropTypes.number,
    studentName: PropTypes.string,
    noQuestions: PropTypes.bool
  })
};

export default Doughnuts;
